import VersionDTO from "../models/Version/VersionDTO";
import { APIService } from "./APIService";

export class VersionService {
	async GetAll(): Promise<VersionDTO> {
		try {
			var response = await APIService.Axios().get<VersionDTO>(
				`${APIService.GetURL()}/Health/version`,
				{
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json",
						Authorization: "Bearer " + APIService.GetToken(),
					},
				},
			);

			if(response.data.version?.length === 0) {
				response.data.version = null;
			}

			if(response.data.samsysApiVersion?.length === 0) {
				response.data.samsysApiVersion = null;
			}

			return response.data;
		} catch (error) {
			return {version: null, samsysApiVersion: null} as VersionDTO;
		}
	}
}